import './events.scss';
/* eslint import/first: 0 */
import eventPages from 'Parties';
import site from 'Site/site';

site();
eventPages();
